import React from 'react'
import { defineMessage } from 'react-intl'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

import { getCarelonDefaultWorkLifeServices } from './default'
import {
  WorkLifeIconCalendar,
  WorkLifeIconDependentCare,
  WorkLifeIconFinancial,
  WorkLifeIconHearts,
  WorkLifeIconPencil,
} from '../atoms/icons/WorkLifeIcons'

export const gap: GetCustomerCopyFunc = () => {
  const CARELON_WORKLIFE_SERVICES = getCarelonDefaultWorkLifeServices('gap')
  return {
    dependentButtonText: defineMessage({
      defaultMessage: 'No, I’m a dependent or household member',
      description: 'Declaring the current user is a dependent of an eligible user',
    }),
    workLifeServices: [
      CARELON_WORKLIFE_SERVICES.LEGAL_SERVICES,
      CARELON_WORKLIFE_SERVICES.FINANCIAL_SERVICES,
      CARELON_WORKLIFE_SERVICES.IDENTITY_THEFT,
      CARELON_WORKLIFE_SERVICES.DEPENDENT_CARE,
      {
        identifiers: {
          id: 'brightHorizons',
          dataTestId: 'workLife-selectBrightHorizons',
        },
        title: 'Bright Horizons Family Support',
        paragraph: '',
        bullets: ['Back Up Childcare', 'Adult and Elder Care', 'Tutoring and Nanny Placement Service Discounts'],
        CTA: 'Register Your Account',
        iconSvg: <WorkLifeIconDependentCare size={48} />,
        PATH: 'https://clients.brighthorizons.com/gapinc',
      },
      {
        identifiers: {
          id: 'nationwidePet',
          dataTestId: 'workLife-selectNationwidePet',
        },
        title: 'Nationwide Pet Insurance',
        iconSvg: <WorkLifeIconHearts size={48} />,
        paragraph: '',
        bullets: [
          '50% - 70% reimbursement based on level of coverage',
          'Choose any vet (no network required) and submit claims for reimbursement',
          '24/7 Vet helpline',
        ],
        CTA: 'Get a Quote',
        PATH: 'http://benefits.petinsurance.com/gap-inc',
      },
      {
        identifiers: {
          id: 'ayco',
          dataTestId: 'workLife-selectAyco',
        },
        title: 'Ayco Digital Financial Platform',
        iconSvg: <WorkLifeIconFinancial size={48} />,
        paragraph: '',
        bullets: [
          'Take control of your personal finances',
          'Plan for your goals, including retirement',
          'Create an investment strategy',
          'Plan for your taxes',
        ],
        CTA: 'Register or Login Now',
        PATH: 'http://www.ayco.com/login/gap',
      },
      {
        identifiers: {
          id: 'tuition',
          dataTestId: 'workLife-selectTuition',
        },
        title: 'Tuition Discounts',
        iconSvg: <WorkLifeIconPencil size={48} />,
        paragraph: '',
        bullets: ['Tuition Reductions', 'Reduced or Waived Payments', 'Discounts for Immediate Family Members'],
        CTA: 'Access Now',
        PATH: 'https://clients.brighthorizons.com/gapinc/matrix',
      },
      {
        identifiers: {
          id: 'wageWorks',
          dataTestId: 'workLife-selectWageWorks',
        },
        title: 'WageWorks Commuter Benefits',
        iconSvg: <WorkLifeIconCalendar size={48} />,
        paragraph: 'Save money on eligible transportation costs through automatic paycheck deductions before taxes.',
        bullets: [],
        CTA: 'Register Your Account',
        PATH: 'https://healthequity.com/',
      },
    ],
  }
}
